<template lang="pug">
// 弹出框查看
div.delayDialog
    el-form(ref='delayForm', :model='delayForm', :rules='rules', label-width='110px' )
        el-form-item(label='议题分类:') 
            el-input(size='mini', style='width:28%', disabled='', v-model='rowdata.consultType')
            |       ~ 
            el-input(size='mini', style='width:28%', disabled='', v-model='rowdata.consultCut') 
            
        el-form-item(label='议题名称:')
            el-input(size='mini', style='width:50%', disabled='', v-model='rowdata.consultName')
        el-form-item(label='关键词:')
            el-input(size='mini', style='width:50%', disabled='', v-model='rowdata.keyWord')
        el-form-item(label='召开时间:')
            el-input(size='mini', style='width:50%', disabled='', v-model='rowdata.holdingTime')
 
        el-form-item(label='所属社区组织:') 
            el-input(size='mini', style='width:28%', disabled='', v-model='rowdata.consultType')
            |       ~ 
            el-input(size='mini', style='width:28%', disabled='', v-model='rowdata.consultCut') 
            
        el-form-item(label='召开地点:')
            el-input(size='mini', style='width:50%', disabled='', v-model='rowdata.place')

        el-form-item(label='召开时间:')
            el-input(size='mini', style='width:50%', disabled='', v-model='rowdata.holdingTime')
       
        el-row( type="flex" class="line_box" justify="space-between")
            div 延迟信息 
  
        el-form-item(label='通知方式: ',prop="noticeWay", class="el-form-item-checkedBox")
            el-checkbox-group( v-model="delayForm.noticeWay")
                el-checkbox(label='1') 短信
                el-checkbox(label='2') 微信 

        el-form-item(label='延迟召开地点:', prop='place', style='margin-bottom: 12px;')
            el-select(size='mini', style='width:50%', v-model='delayForm.place', placeholder='--请选择--')
                el-option(v-for='item in selectAreas', :key='item.value', :label='item.label', :value='item.label')

        el-form-item(label='延迟召开时间:', prop='holdingTime', style='margin-bottom: 14px;'  )
            el-date-picker(v-model='delayForm.holdingTime', type='datetime', value-format='yyyy-MM-dd HH:mm:ss', size='mini', style='width:50%', placeholder='选择日期时间')
        el-form-item(label='延迟原因: ', prop='delay' )
            el-input(type='textarea', style='width:50%', :rows='4', placeholder='请输入内容', v-model='delayForm.delay')

    .boontbtn
        el-button(type='primary', size='small', style='margin: 0 30px', @click='saveAuditdata') 保存
        el-button(type='info', size='small', @click='closeDialog') 关闭
 

</template>

<script>
import { consulApi } from "@/api/http.js";
import baseForm from "./baseForm.vue";
import peopleTypeDialogDelay from "./peopleTypeDialogDelay.vue";
let token = JSON.parse(window.localStorage.getItem("user"));
export default {
  name: "ViewDelay",
  props: ["rowid"],
  components: {
    baseForm,
    peopleTypeDialogDelay
  },
  data() {
    return {
      rules: {
        holdingTime: [
          { required: true, message: "延迟召开时间不能为空", trigger: "change" }
        ],
        place: [
          { required: true, message: "延迟地点时间不能为空", trigger: "blur" }
        ],
        delay: [
          { required: true, message: "延迟原因不能为空", trigger: "blur" }
        ],
        noticeWay: [
          { required: true, message: "通知方式不能为空", trigger: "change" }
        ]
      },
      selectAreas: [],
      id: this.rowid,
      rowdata: {},
      oldHoldingTimes: "",
      delayForm: {
        noticeWay: [],
        holdingTime: "",
        place: "",
        delay: ""
      },
      isShow: false
    };
  },
  methods: {
    choosePeopleTypeFunc(val) {
      console.log(val);
    },
    //点击查看显示弹出层
    async getData() {
      this.isShow = true;
      //编辑
      if (this.id != "") {
        //获取编辑项的最新数据
        let fd = new FormData();
        fd.append("token", token);
        fd.append("id", this.id);
        var res = await consulApi.getDetail(fd);

        // console.log(res)
        if (res.code == 200) {
          this.rowdata = res.content;
        } else {
          this.rowdata = {};
          console.log(res.code + "：" + res.message);
          this.$message({
            message: "数据项加载异常",
            type: "error"
          });
        }

        this.$refs.delayForm.clearValidate();
      } else {
        this.$message({
          message: "数据传输异常",
          type: "error"
        });
        this.rowdata = {};
        this.$emit("func", []);
      }
    },
    saveAuditdata() {
      this.$refs.delayForm.validate(valid => {
        if (valid) {
          this.saveAuditdata2();
        } else {
          this.$message({
            message: "请输入正确信息",
            type: "error"
          });
          return false;
        }
      });
    },
    //审批接口
    async saveAuditdata2() {
      this.delayForm.id = this.rowdata.id;
      this.delayForm.oldHoldingTimes = this.rowdata.holdingTime;
      this.delayForm.noticeWay = this.delayForm.noticeWay.join(",");

      var res = await consulApi.delay(this.delayForm);
      if (res.code == 200) {
        this.$message({
          message: "保存成功",
          type: "success"
        });
        this.$emit("func", []);
      } else {
        console.log(res);
        this.$message({
          message: "保存失败：" + res.message,
          type: "error"
        });
      }
    },
    //获取召开地址列表
    async getAreas() {
      let fd = new FormData();
      fd.append("token", token);
      fd.append("pageNo", 1);
      fd.append("pageSize", 20);
      let params = JSON.stringify({ status: "0" });
      fd.append("findConsultAddress", params);
 
      var res = await consulApi.findConsultAddress(fd);
      // console.log(res)
      this.selectAreas = [];
      if (res.code == 200 && res.content.count > 0) {
        res.content.list.forEach(item => {
          var temp = {
            value: item.id,
            label: item.province + item.city + item.area + item.detailed
          };
          this.selectAreas.push(temp);
        });
      }
    },
    closeDialog() {
      this.isShow = false;
      this.$refs.delayForm.clearValidate();
      this.$emit("func", []);
    }
  },
  mounted() {
    this.getData();
    this.getAreas();
    this.isShow = true;
  },
  beforeDestroy() {}
};
</script>
 <style lang="less">
.delayDialog {
  .el-form-item-checkedBox {
    .el-form-item__error {
      top: 85%;
    }
  }
  .line_box {
    align-items: center;
    border-bottom: 1px solid#ddd;
    padding-bottom: 10px;
    margin-bottom: 20px;
    margin-top: 20px;
    color: #333;
    font-size: 15px;
    font-weight: 700;
  }
}
</style>